<template>
    <div v-if="isShow" class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex justify-center items-center z-[100] px-4 transition-all duration-300"
        @click.self="closePopup()">
        
        <!-- Modal Container -->
        <div class="relative bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl border border-white/20 w-full max-w-[420px] overflow-hidden flex flex-col"
            :class="{ 'animate-popupFadeIn': isVisible, 'animate-popupFadeOut': !isVisible }">
            
            <!-- Header -->
            <div class="relative w-full bg-brand p-4 text-yellow-500 font-bold text-[16px] tracking-wide flex-shrink-0 flex items-center justify-between shadow-sm" style="background-color: var(--color-brand);">
                <div class="flex items-center gap-2">
                    <font-awesome-icon :icon="['fas', 'file-invoice-dollar']" class="text-lg" />
                    <span>Xác nhận xuất chi</span>
                </div>
                <button @click="closePopup()"
                    class="w-8 h-8 rounded-full bg-white/10 hover:bg-red-500 text-white/90 hover:text-white transition-colors flex items-center justify-center cursor-pointer shadow-sm">
                    <font-awesome-icon :icon="['fas', 'xmark']" />
                </button>
            </div>

            <!-- Body -->
            <div class="p-6 text-center">
                <div class="w-14 h-14 bg-amber-50 rounded-full flex items-center justify-center mx-auto mb-4 border border-amber-100 text-amber-500 text-2xl shadow-sm">
                    <font-awesome-icon :icon="['fas', 'circle-exclamation']" />
                </div>
                
                <h3 class="text-base font-bold text-gray-800 mb-1">Xác nhận xuất chi phiếu</h3>
                <p class="text-sm text-gray-500 mb-6 leading-relaxed">
                    Bạn có chắc chắn muốn xuất chi phiếu này không? Trạng thái phiếu sẽ được cập nhật thành "Đã chi".
                </p>

                <!-- Actions -->
                <div class="flex items-center justify-center gap-3">
                    <button @click="closePopup()"
                        class="flex-1 py-2.5 px-4 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-xl text-sm transition-colors shadow-sm cursor-pointer">
                        Hủy
                    </button>
                    <button @click="updateStatus(propCode)"
                        class="flex-1 py-2.5 px-4 bg-brand hover:bg-brand/90 text-white font-bold rounded-xl text-sm transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-2 cursor-pointer">
                        <font-awesome-icon :icon="['fas', 'check']" />
                        <span>Xuất chi</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const API_URL = process.env.VUE_APP_API_URL
export default {
    components: {

    },
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
        propCode: {
            type: [String, Number],
            default: () => { }
        }
    },
    data() {
        return {
            isVisible: true,
        };
    },

    computed: {

    },
    mounted() {
    },
    methods: {
        closePopup() {
            this.isVisible = false
            setTimeout(() => {
                this.$emit('closed');
            }, 200);
        },
        async updateStatus(id) {
            const data = {
                approvePaymentStatus: 2
            };

            await this.$axios.put(`${API_URL}/bills/update/${id}`, {
                type: 'paymentStatus',
                data
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Authorization': `Bearer ${this.$app.token}`,
                },
            }).then(res => {
                this.$notify.success({
                    title: 'Thành công',
                    message: 'Cập nhật trạng thái thành công.'
                });
                this.closePopup();
                this.$emit('reload');
            }).catch(err => {
                console.log(err);
                this.$notify.error({
                    title: 'Thất bại',
                    message: 'Xảy ra lỗi khi cập nhật trạng thái.'
                });
            });
        },

    }
};
</script>

<style scoped>
@keyframes popupFadeIn {
    0% {
        opacity: 0;
        transform: translateY(10px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes popupFadeOut {
    0% {
        opacity: 1;
        transform: translateY(0);
    }

    100% {
        opacity: 0;
        transform: translateY(10px);
    }
}

.animate-popupFadeIn {
    animation: popupFadeIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.animate-popupFadeOut {
    animation: popupFadeOut 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}
</style>